import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

const AppWrapper = () => {
  return (
    <div
      style={{
      
      }}
    >
      <App />
    </div>
  );
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<AppWrapper />);
